// @ts-strict-ignore
import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {IronContextRegistry} from 'common/report/context-registry';

import {template} from './template';
import css from './index.inline.styl';

type ODAControlState = {
  isUpsellModalOpen: boolean;
};

export type ODAControlAttrs = {
  description: string;
  'is-waiting-for-schedule-analysis': boolean;
  'show-upsell': boolean;
  'upsell-description': string;
};

export class ODAControl extends Component<ODAControlState, ODAControlAttrs, unknown, unknown, IronContextRegistry> {
  static get attrsSchema(): AttrsSchema<ODAControlAttrs> {
    return {
      description: `string`,
      'is-waiting-for-schedule-analysis': `boolean`,
      'show-upsell': `boolean`,
      'upsell-description': `string`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      contexts: [`i18n` as const],
      helpers: {
        handleClickAnalyze: () => this.dispatchEvent(new CustomEvent(`clickAnalyze`)),
        handleClickUpsell: () => this.update({isUpsellModalOpen: true}),
        handleChangeUpsellModal: (ev) => {
          if (ev.detail.state === `closed`) {
            this.update({isUpsellModalOpen: false});
          }
        },
      },
      defaultState: {
        isUpsellModalOpen: false,
      },
    };
  }
}

export const ODAControlEl = defineAndMakeJsxFactory(`mp-oda-control`, ODAControl);
export const ODAControlReact = panel2react(`mp-oda-control`, ODAControl);
